




import { Component, Vue } from 'vue-property-decorator';
import LoyaltyTransactionPage from '@/componentsV2/organisms/TransactionList/Detail/TransactionItemDetailPortal.vue';

@Component({
  components: {
    LoyaltyTransactionPage
  }
})
export default class LoyaltyTransaction extends Vue {}
